module.exports = __webpack_public_path__ + "img/2I.88fbe638.png";